var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_c('span', [_vm._v("회원 통계")])]), _c('console-body', [_c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("일간 방문자수")]), _c('v-chart', {
    attrs: {
      "data": _vm.historyDailyStatistics.count,
      "x-axis-data": _vm.historyDailyStatistics.xAxisData
    }
  })], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("연간 가입자수")]), _c('v-chart', {
    attrs: {
      "data": _vm.yearlyStatistics.count,
      "x-axis-data": _vm.yearlyStatistics.xAxisData
    }
  })], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("월간 가입자수")]), _c('v-chart', {
    attrs: {
      "data": _vm.monthlyStatistics.count,
      "x-axis-data": _vm.monthlyStatistics.xAxisData
    }
  })], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("일간 가입자수")]), _c('v-chart', {
    attrs: {
      "data": _vm.dailyStatistics.count,
      "x-axis-data": _vm.dailyStatistics.xAxisData
    }
  })], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("지역별 회원수")]), _c('v-card-text', [_c('v-graph', {
    attrs: {
      "data": _vm.areasStatistics.count,
      "x-axis-data": _vm.areasStatistics.xAxisData
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("등급별 회원수")]), _c('v-card-text', [_c('v-graph', {
    attrs: {
      "data": _vm.levelsStatistics.count,
      "x-axis-data": _vm.levelsStatistics.xAxisData
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }